// extracted by mini-css-extract-plugin
export default {"brandsSwiper":"brands_brandsSwiper__m8sar","brands":"brands_brands__2xS4F"};